import FadeInSection from "../../ui/fade-in-section";

export default function UseCasesHero() {
  return (
    <section className="relative bg-white pt-20 sm:pt-24 pb-10 sm:pb-16 overflow-hidden">
      <div className="absolute inset-0 saas-hero-mesh" aria-hidden />
      <div
        className="absolute top-0 right-0 w-[480px] h-[480px] rounded-full bg-teal/5 blur-3xl -translate-y-1/2 translate-x-1/4 pointer-events-none"
        aria-hidden
      />

      <div className="page-container relative z-10">
        <FadeInSection immediate y={20} duration={0.5}>
          <div className="max-w-3xl">
            <span className="home-eyebrow">AI Use Cases</span>

            <h1 className="mt-5 sm:mt-6 text-[1.75rem] sm:text-[2.5rem] lg:text-[3rem] font-bold text-navy leading-[1.15] tracking-tight text-balance">
              AI that does real work.{" "}
              <span className="text-slate-700">For real businesses.</span>
            </h1>

            <p className="mt-4 sm:mt-6 text-[15px] sm:text-lg text-slate-500 leading-relaxed max-w-2xl">
              Every use case below is something we have built or are actively
              building. Try the live demos, see how the AI thinks, and tell us
              which one fits your business.
            </p>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}
